// src/components/terms/GenericContentPage.jsx
import React from 'react';
import CommonPaper from '../common/CommonPaper';
import Container from '@mui/material/Container';
import { styled } from '@mui/material/styles';

export const WEBSITE = 'dietaniemowlaka.pl';
export const EMAIL = 'kontakt@dietaniemowlaka.pl';
export const DIETA_NIEMOWLAKA_DATA = 'osobę fizyczną - Radosława Grzesiaka';

const Root = styled(Container)(({ theme }) => ({
  padding: theme.spacing(4, 2),
}));

const StyledContent = styled('div')(({ theme }) => ({
  textAlign: 'justify',
  margin: theme.spacing(1),
}));

const StyledSection = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(3),
}));

const CommonTermsPage = ({ title, sections }) => {
  return (
    <Root>
      <h2>{title}</h2>
      <StyledContent>
        {sections.map((section, index) => (
          <StyledSection key={index}>
            <h3>{section.heading}</h3>
            <p>{section.content}</p>
          </StyledSection>
        ))}
      </StyledContent>
    </Root>
  );
};

export default CommonTermsPage;